import React from "react";
import get from "lodash/get";
import at from "lodash/at";
import ReactGA from "react-ga";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "react95";
import useSelectedScraper from "../../hooks/useSelectedScraper";
import { fetchBlobUrl, resetBlob } from "../../reducers/trackBlob";
import { setSelectedTrack, clearSelectedTrack } from "../../reducers/trackDetails";

export const TrackTitle = (props) => {
    const dispatch = useDispatch();
    const selectedScraper = useSelectedScraper();

    const selectedStreamUrl = useSelector((state) =>
        get(state, `trackDetails.${selectedScraper}.value.stream_url`)
    );

    const rowId = get(props, "cell.row.id");
    const trackData = get(props, `data.${rowId}`, null);

    const [trackTitle, trackStreamUrl] = at(trackData, "title", "stream_url");

    const toggleTrack = () => {
        if (selectedStreamUrl === trackStreamUrl) {
            dispatch(clearSelectedTrack());
            return dispatch(resetBlob());
        }
        dispatch(fetchBlobUrl(trackStreamUrl));
        ReactGA.event({
            category: "User",
            action: `Toggled track ${trackTitle}`
        });
        return dispatch(setSelectedTrack(trackData));
    };

    return (
        <div>
            <Checkbox
                defaultChecked={false}
                onChange={() => toggleTrack()}
                checked={selectedStreamUrl === trackStreamUrl}
                value={trackStreamUrl}
            />
            {trackTitle}
        </div>
    );
};

export default TrackTitle;
